(() => {
  const normalize = value => value.toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bp26-directory]').forEach(root => {
      if (root.dataset.bp26Ready) return;
      const input = root.querySelector('[data-bp26-filter-input]');
      const tools = root.querySelector('[data-bp26-filter-tools]');
      const counter = root.querySelector('[data-bp26-filter-count]');
      if (!input || !tools || !counter) return;
      const cards = [...root.querySelectorAll('[data-bp26-filter-card]')];
      if (!cards.length) return;
      root.dataset.bp26Ready = 'true';
      tools.hidden = false;
      const apply = () => {
        const query = normalize(input.value.trim());
        let count = 0;
        for (const card of cards) {
          card.hidden = !normalize(card.dataset.name || '').includes(query);
          if (!card.hidden) count++;
        }
        counter.textContent = (counter.dataset.label || '').replace('[aantal]', String(count));
      };
      input.addEventListener('input', apply);
      apply();
    });
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bp26-cookie-preferences]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-bp26-cookie-status]');
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('unavailable');
      await window.privacyBanner.showPreferences();
      if (status) status.textContent = '';
    } catch {
      if (status) status.textContent = button.dataset.error || document.documentElement.dataset.bp26CookieError || '';
    }
  });
  document.querySelectorAll('[data-bp26-wishlist]').forEach(root => {
    const content = root.querySelector('[data-bp26-wishlist-content]');
    const fallback = root.querySelector('[data-bp26-wishlist-fallback]');
    if (!content || !fallback) return;
    const update = () => { fallback.hidden = !!content.textContent.trim(); };
    new MutationObserver(update).observe(content, { childList: true, subtree: true, characterData: true });
    update();
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
